import {
  takeEvery, all, call, put, select, putResolve,
} from 'redux-saga/effects';

import {
  apiGetAccount,
} from './api';

import {
  getAccountActions,
  getAccountActionTypes,
  updateSelectedAccountActionTypes,
  updateSelectedAccountActions,
  onAccountChangedAction,
} from './actions';

function* fetchAccount() {
  try {
    yield put(getAccountActions.request());
    const { companyId } = yield select((state) => state.appService);
    const response = yield call(() => apiGetAccount(companyId));
    const responseJson = yield response.json();
    yield put(getAccountActions.success({
      ...responseJson.data,
    }));
  } catch (error) {
    yield put(getAccountActions.error(error));
  }
}

function* watchGetAccount() {
  yield takeEvery(getAccountActionTypes.common, fetchAccount);
}

function* updateSelectedAccount({ accountId }) {
  const account = yield select((state) => state.accountService.normalizedAccounts[accountId]);
  yield putResolve(updateSelectedAccountActions.success(account));
  yield put(onAccountChangedAction());
}

function* watchChangeAccount() {
  yield takeEvery(updateSelectedAccountActionTypes.common, updateSelectedAccount);
}

export default function* root() {
  yield all([
    watchGetAccount(),
    watchChangeAccount(),
  ]);
}
